import { render, staticRenderFns } from "./UpdateInfoDetail.vue?vue&type=template&id=0039dd02&"
import script from "./UpdateInfoDetail.vue?vue&type=script&lang=js&"
export * from "./UpdateInfoDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports